import { types, applySnapshot } from 'mobx-state-tree'
import makeInspectable from 'mobx-devtools-mst';
// Services
import { ChatStore } from './chatStore'
import { UIStore } from './uiStore'
import { AuthStore } from './authStore'
import { PaymentStore } from './paymentStore'
import { RouterStore } from './routerStore'
import { IntercomStore } from './intercomStore'
import { ParkingFlowStore } from './parkingTicket/flow'
import UserPlates from '~/stores/models/UserPlates'
import UserTrafficTickets from '~/stores/models/UserTrafficTickets'
// Site Areas
import { TrafficSubmissionStore } from './trafficTicket/submissionStore'
import TrafficLookupStore from './trafficTicket/lookupStore'
import DivorceLookupStore from './divorce/lookupStore'
import UserParkingTickets from '~/stores/models/UserParkingTickets'
import UserFromRobotTickets from '~/stores/models/UserFromRobotTickets'


let store = null

export const defaultStore = {
  // Services
  chat: {},
  ui: {
    lastUpdate: Date.now(),
    toasts: { shownIds: [] }
  },
  auth: { user: {} },
  intercom: {},
  router: {},
  payment: {},
  // Site Areas
  trafficSubmission: {
    trafficRegion: null
  },
  parkingFlow: {},
  trafficLookup: {},
  divorceLookup: {},
  plates: {},
  parkingTickets: {},
  trafficTickets: {},
  robotTickets: {}
}

export const AppStore = types.model('AppStore', {
  // Services
  chat: types.optional(ChatStore, defaultStore.chat),
  ui: types.optional(UIStore, defaultStore.ui),
  intercom: types.optional(IntercomStore, defaultStore.intercom),
  router: types.optional(RouterStore, defaultStore.router),
  auth: types.optional(AuthStore, defaultStore.auth),
  payment: types.optional(PaymentStore, defaultStore.payment),
  // Site Areas
  trafficSubmission: types.optional(
    TrafficSubmissionStore,
    defaultStore.trafficSubmission
  ),
  parkingFlow: types.optional(ParkingFlowStore, defaultStore.parkingFlow),
  trafficLookup: types.optional(TrafficLookupStore, defaultStore.trafficLookup),
  divorceLookup: types.optional(DivorceLookupStore, defaultStore.divorceLookup),
  plates: types.optional(UserPlates, defaultStore.plates),
  parkingTickets: types.optional(UserParkingTickets, defaultStore.parkingTickets),
  trafficTickets: types.optional(UserTrafficTickets, defaultStore.trafficTickets),
  robotTickets: types.optional(UserFromRobotTickets, defaultStore.robotTickets)
})

export function initStore(isServer, snapshot = null) {
  if (isServer) {
    store = AppStore.create(defaultStore)
  }
  if (store === null) {
    store = AppStore.create(defaultStore)
  }
  if (process.browser && process.env.WINIT_ENV !== "production") {
    makeInspectable(store)
  }
  if (snapshot) {
    applySnapshot(store, snapshot)
  }
  return store
}
